import CMSPageModel from '../models/CMSPage';

export const currentPortalPage = new CMSPageModel({}, {parse: false});
